import toastr from 'toastr';
import 'url-search-params-polyfill';

toastr.options = {
  positionClass: 'toast-bottom-left',
};

$(function () {
  const updateElementClass = (element, className, add = true) => {
    element[add ? 'addClass' : 'removeClass'](className);
  };

  // Cart functionality
  const updateCartCount = () => {
    const count = Object.keys(cart_object.cart_total || {}).length; // eslint-disable-line

    if (count > 0) {
      const cartBadge = `<span class="cart-total">${count}</span>`;
      $('.top-bar .btn--cart a, .collapse__wrapper .btn--cart').prepend(
        cartBadge
      );
    }
  };

  // Quantity adjustment
  const adjustQuantity = (id, increment = true) => {
    const target = $(`#${id}`);
    const value = +target.val();

    if (!increment && value <= 0) return;
    target.val(value + (increment ? 1 : -1));
  };

  // Filter application
  const applyFilter = (element, filter, filterToRemove = '') => {
    if (element.hasClass('loading')) return;

    updateElementClass(element, 'loading');
    element.html(
      `<span class="spinner-border spinner-border-sm"></span>${element.html()}`
    );

    const searchParams = new URLSearchParams(window.location.search);

    if (filterToRemove) {
      filterToRemove.split(',').forEach((f) => searchParams.delete(f));
    }

    searchParams.delete('product-page');

    if (element.data(filter)) {
      searchParams.set(filter, element.data(filter));
    } else {
      searchParams.delete(filter);
    }

    window.location.href = `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`;
  };

  // Initialize functionality
  updateCartCount();

  $('[data-plus-one]').on('click', function () {
    adjustQuantity($(this).data('plusOne'));
  });

  $('[data-minus-one]').on('click', function () {
    adjustQuantity($(this).data('minusOne'), false);
  });

  $('.woocommerce-filters a[data-filter]').on('click', function (e) {
    e.preventDefault();
    applyFilter($(this), 'filter', 'filterToRemove');
  });

  $('.woocommerce-pagination .prev').html(
    '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-arrow-left fa-w-14"><path fill="currentColor" d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"></path></svg>'
  );
  $('.woocommerce-pagination .next').html(
    '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-arrow-right fa-w-14"><path fill="currentColor" d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4-9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"></path></svg>'
  );
});
